// extracted by mini-css-extract-plugin
export default {"leave-encash-header":"LeaveEncashmentReport_leave-encash-header__KYmqe","divider":"LeaveEncashmentReport_divider__6hxJB"};